import { createAction } from "redux-actions";
import { CHANGE_SEGMENT, PREFILL_SEGMENT } from "./constants";

export const changeSegment = createAction(CHANGE_SEGMENT);
export const prefillSegment = createAction(PREFILL_SEGMENT);
